export const iconFontAwesomeHouseholdTv = (
	<i className="fa-solid fa-tv"></i>
);
